module.exports = __webpack_public_path__ + "static/media/Skyfarm Drive, Santa Rosa, CA6.f0a21ce7.jpg";